import {THEME} from '@wandb/weave/common/css/color.styles';
import styled from 'styled-components';

export const ConfigOption = styled.div`
  margin-top: 0.5rem;
  margin-bottom: 0.5rem;
  display: flex;
  align-items: top;
`;

export const ConfigOptionLabel = styled.div`
  width: 70px;
  padding-top: 0px;
  flex-shrink: 0;
  color: ${'light-dark(#aaa, var(--moon-400))'};
`;

export const ConfigOptionField = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1 1 auto;
`;
